export const API_CONFIG = {
  BASE_URL: '/api/v1',
  TIMEOUT: 40000, // 40 seconds to handle model inference + fallback analysis
};

export const APP_CONFIG = {
  MAX_CONVERSATIONS: 100,
  AUTO_SAVE_INTERVAL: 5000,
};